import Vue from 'vue'
import router from './router'
import VueLocalForage from 'vue-localforage'
import VueTouch from 'vue-touch'
// https://github.com/euvl/vue-js-modal
import VModal from 'vue-js-modal'
import Ripple from 'vue-ripple-directive'
import './registerServiceWorker'
import {
  Input,
  InputNumber,
  Radio,
  Checkbox,
  Switch,
  Select,
  Option,
  Button,
  DatePicker,
  Form,
  FormItem,
  Icon,
  Collapse,
  CollapseItem,
  Loading,
  Message,
  Progress
} from 'element-ui'
import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'

import App from './App'

import Axios from './plugins/my-axios'
import DeviceLib from './plugins/device-lib'
import GtmDataLayer from './plugins/gtm-datalayer'
import EventHub from './plugins/event-hub'

import FirebaseLib from './plugins/firebase-lib.js'
import FormLib from './plugins/form-lib'

import Site from './plugins/site'
import Varuna from './plugins/varuna'
import Yagi from './plugins/yagi'
import YourYagi from './components/YourYagi'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)


locale.use(lang)

Vue.use(router)
Vue.use(Site)
Vue.use(Axios)

/* element-ui */
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Switch)
Vue.use(Select)
Vue.use(Option)
Vue.use(Button)
Vue.use(DatePicker)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Icon)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Loading.directive)
Vue.prototype.$message = Message
Vue.use(Progress)

Vue.use(VueLocalForage)
Vue.use(VueTouch, { name: 'v-touch' })
Vue.use(VModal)

Vue.use(EventHub)
Vue.use(DeviceLib)
Vue.use(GtmDataLayer)
Vue.use(FormLib)
Vue.use(FirebaseLib)
Vue.use(Varuna)
Vue.use(Yagi)

// globally (in your main .js file)
Vue.component('your-yagi', YourYagi)

Ripple.color = 'rgba(255, 255, 255, 0.25)'
Vue.directive('ripple', Ripple)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})
